import { carmaCsrAuthClient } from 'src/services/instance/carmaCsrAuthClient';
import { ProfileApiResponse } from './ProfileApi.types';

/**
 * Request a quote
 */
export const getProfile = (): Promise<ProfileApiResponse> =>
  carmaCsrAuthClient.get<ProfileApiResponse>(`me/profile`).json();
